import React from 'react'
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import Box from '@material-ui/core/Box';

const CardPreview = ({ setDisplayCardForm }) => {
  
  return (
    <Grid 
      container 
      item 
      justifyContent="space-between" 
    >
      <Grid item>
        <Typography variant="body1" gutterBottom>
          <CreditCardIcon /> &bull;&bull;&bull; 0000|MM/YY
        </Typography >
      </Grid>

      <Grid component={Box} item alignSelf='center' >
        <Button 
          onClick={() => setDisplayCardForm(true)} 
          variant="contained" 
          color="primary"
        >
          Add
        </Button>
      </Grid>
    </Grid>
  )
}

export default CardPreview;